import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MicrosoftTeamsAutoAttendantReferenceView,
  MicrosoftTeamsAutoAttendantView,
} from '../../shared/models/generated/ziroModels';

@Injectable()
export class TeamsAutoAttendantsViewResource {
  private _httpClient = inject(HttpClient);

  getAutoAttendantView(tenantId: string, autoAttendantId: string): Observable<MicrosoftTeamsAutoAttendantView> {
    return this._httpClient.get<MicrosoftTeamsAutoAttendantView>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/detailed-views/${autoAttendantId}`,
    );
  }

  getReferences(tenantId: string, autoAttendantId: string): Observable<MicrosoftTeamsAutoAttendantReferenceView[]> {
    return this._httpClient.get<MicrosoftTeamsAutoAttendantReferenceView[]>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/detailed-views/${autoAttendantId}/references`,
    );
  }
}
